import TextUtil from "../../../../../lib/html5-software-library/src/ranj/components/text/TextUtil";

export var UnderlinedTextDecorator = function (textObject) {
    return function () {
        var wrappedTextObject = textObject;
        applyUnderline(wrappedTextObject);

        return wrappedTextObject;
    }
}

var applyUnderline = function (textObject) {
    var measuredHeight = textObject.getMeasuredHeight();
    var underline = new Underline(textObject);

    if (textObject.parent) {
        textObject.parent.addChild(underline);

        const fontName = TextUtil.getFontName(textObject);
        const fontSize = TextUtil.getFontSize(textObject);
        underline.x = textObject.x; // + TextOffsetFixer.instance.getCorrectionX(fontName, fontSize, textObject.textAlign);
        underline.y = textObject.y + measuredHeight + 4; // - TextOffsetFixer.instance.getCorrectionY(fontName, fontSize);
    }

    textObject.underline = underline;
}

class Underline extends createjs.Shape {
    constructor(textObject) {
        super();

        this._textObject = textObject;
        this.redraw();
    }

    redraw() {
        this.graphics
            .clear()
            .beginStroke(this._textObject.color)
            .moveTo(0, 0)
            .lineTo(this._textObject.getMeasuredWidth(), 0);
    }
}